import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';

// Components
import Button from '../Button';
import Popup from '../Popup';
import Profile from './Profile';
import Forms from './Forms';

// State
import { showPopup, hidePopup } from '../../state/modules/popup';
import { signOut } from '../../state/modules/user/actions';

// Styles
import styles from './AuthModule.styl';

const cx = classNames.bind(styles);

export default function AuthModule(props) {
  const { className } = props;

  const dispatch = useDispatch();
  // const location = useLocation();
  const { isOpen } = useSelector(state => state.popup.list?.auth) || {};
  const isAuthenticated = useSelector(state => state.user.isAuthenticated);

  const showSignIn = () => {
    return dispatch(showPopup('auth', { step: 'signIn' }));
  };

  const onHide = () => {
    return dispatch(hidePopup('auth'));
  };

  const onSignOut = () => {
    return dispatch(signOut());
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     dispatch(hidePopup('auth'));
  //   }
  // }, [location.pathname]);

  return (
    <div className={cx('AuthModule', className)}>
      {isAuthenticated ? (
        <Profile onSignOut={onSignOut} />
      ) : (
        <Button
          className={cx('AuthModule__button')}
          onClick={showSignIn}
          secondary
          disabled={Boolean(isOpen)}
        >
          <FormattedMessage id="button.login" />
        </Button>
      )}
      <Popup isOpen={Boolean(isOpen)} onHide={onHide}>
        <Forms />
      </Popup>
    </div>
  );
}

AuthModule.defaultProps = {
  className: '',
};

AuthModule.propTypes = {
  className: PropTypes.string,
};
